<template>
  <form
    ref="form"
    class="login__form"
    @submit.prevent="valid() ? checkIfUserHasBeenMigrated() : null"
    novalidate>
    <sc-field>
      <sc-input
        type="email"
        name="email"
        ref="email"
        placeholder="Informe seu e-mail"
        v-model="form.email"
        :disabled="loading"
        @blur="$emit('update:email', form.email)"
        required />
    </sc-field>

    <sc-field>
      <sc-button
        type="submit"
        theme="primary"
        class="is-fullwidth"
        text="Próximo"
        :loading="loading" />
    </sc-field>
  </form>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';

  import {
    Http,
    Storage,
    Moment,
    Auth,
  } from '@intelipost-js/secure-providers';
  import {
    ScField,
    ScSwitch,
    ScInput,
    ScButton,
    // ScToast,
  } from '@intelipost-js/secure-components';

  const { mapMutations, mapActions, mapGetters } = createNamespacedHelpers('auth');
  export default {
    name: 'form-email',
    data() {
      return {
        loading: false,
        storageEmailKey: 'lastEmail',
        form: {
          email: '',
          persistData: false,
        },
      };
    },
    computed: {
      ...mapGetters([
        'getAuth',
      ]),
    },
    methods: {
      ...mapActions([
        'getEmailCheck',
        'getBearerToken',
      ]),
      ...mapMutations([
        'setAuth',
      ]),
      async checkIfUserHasBeenMigrated() {
        try {
          this.loading = true;

          const { data: { content: { migrated } } } = await Http.post('api/v1/user/migrated', {
            email: this.form.email,
          });
          Storage.set('userMigrated', migrated, 'local');
          if (migrated) {
            this.checkTypeLogin();
          } else {
            Storage.set(this.storageEmailKey, this.form.email);
            this.loading = false;
            this.$emit('update:isEmailCheck', false);
          }
        } catch (e) {
          this.loading = false;
        }
      },
      async checkTypeLogin() {
        this.loading = true;
        const params = this.form;
        let resultCheckEmail = null;
        try {
          resultCheckEmail = await this.getEmailCheck(params);
        } catch (error) {
          this.loading = false;
        } finally {
          this.loading = false;
        }
        const isSSOLoginType = resultCheckEmail.enable_sso;
        if (isSSOLoginType) {
          Storage.set('isLoginSSO', true, 'local');
          Storage.set('emailSSO', this.form.email, 'local');
          this.getAuth.userhandler = {
            onSuccess: async (result) => {
              const accessToken = result.accessToken.jwtToken;
              this.getBearerToken({
                jwtToken: accessToken,
                user: Storage.get('cognito_data', 'local').UserPoolId,
              }).then((loginResponse) => {
                const { authf2 } = loginResponse;
                if (authf2) {
                  this.$emit('update:email', this.form.email);
                  this.$emit('update:isTwoFactorAuth', authf2);
                  return false;
                }
                const { client = {}, user = {} } = loginResponse;
                const {
                  sandbox_id = null,
                  id: client_id = null,
                } = client;
                const { security } = user;
                Auth.updateUser(Object.assign(user, {
                  client_id,
                  sandbox_id,
                  security: {
                    ...security,
                    session_start: Moment(),
                  },
                }));
                this.$store.dispatch('notifications/getNotifications')
                .then(() => {
                  this.logUser();
                });
                return Auth.setMenu();
              })
              .catch(() => {
                this.loading = false;
              }).finally(() => {
                this.loading = false;
              });
            },
          };
          this.getAuth.getSession();
        } else {
          Storage.set('isLoginSSO', false, 'local');
          this.$emit('update:email', this.form.email);
          this.$emit('update:isEmailCheck', false);
        }
      },
      valid() {
        const { email } = this.$refs;
        return email.checkHtml5Validity();
      },
      checkHasAcessTokenParam(hash) {
        return hash.search('access_token') > 0;
      },
      logUser() {
        this.loading = false;
        if (this.form.saveEmail) {
          Storage.set(this.storageEmailKey, this.form.email);
        } else {
          Storage.remove(this.storageEmailKey);
        }
        Storage.set('RemoteAccess', { status: false });
        const path = this.$route.query.redirect || '/welcome';
        this.$router.push({ path });
      },
      sendLogin(params) {
        Storage.set('originMenu', 'newmenu', 'local');
        if (this.getdiffdays <= 90) {
          Storage.set('originMenu', 'oldmenu', 'local');
        }
        return this.getLoginSSO(params).then((loginResponse) => {
          const { authf2 } = loginResponse;
          if (authf2) {
            this.$emit('update:email', this.form.email);
            this.$emit('update:isTwoFactorAuth', authf2);
            return false;
          }
          const { client = {}, user = {} } = loginResponse;
          const {
            sandbox_id = null,
            id: client_id = null,
          } = client;
          const { security } = user;
          Auth.updateUser(Object.assign(user, {
            client_id,
            sandbox_id,
            security: {
              ...security,
              session_start: Moment(),
            },
          }));
          this.$store.dispatch('notifications/getNotifications')
          .then(() => this.logUser());
          return Auth.setMenu();
        })
        .catch(() => { this.loading = false; });
      },
    },
    mounted() {
      if (!this.checkHasAcessTokenParam(this.$route.hash)) {
        Storage.remove('cognito_data', 'local');
        Storage.remove('isLoginSSO', 'local');
      }
      if (Storage.get('cognito_data', 'local') && Storage.get('isLoginSSO', 'local')) {
        this.loading = true;
        this.form.email = Storage.get('emailSSO', 'local');
        Storage.set('originMenu', 'newmenu', 'local');
        this.getAuth.userhandler = {
          onSuccess: async (result) => {
            this.loading = true;
            const accessToken = result.accessToken.jwtToken;
            this.getBearerToken({
              jwtToken: accessToken,
              user: Storage.get('cognito_data', 'local').UserPoolId,
            }).then((loginResponse) => {
              const { authf2 } = loginResponse;
              if (authf2) {
                this.$emit('update:email', this.form.email);
                this.$emit('update:isTwoFactorAuth', authf2);
                return false;
              }
              const { client = {}, user = {} } = loginResponse;
              const {
                sandbox_id = null,
                id: client_id = null,
              } = client;
              const { security } = user;
              Auth.updateUser(Object.assign(user, {
                client_id,
                sandbox_id,
                security: {
                  ...security,
                  session_start: Moment(),
                },
              }));
              this.$store.dispatch('notifications/getNotifications').then(() => {
                this.logUser();
              });
              return Auth.setMenu();
            }).catch(() => {
              this.loading = false;
              Storage.remove('isLoginSSO', 'local');
              Storage.remove('emailSSO', 'local');
              Storage.remove('cognito_data', 'local');
              this.getAuth.signOut();
            });
            Storage.set('persistData', 'local', 'local');
          },
          onFailure(err) {
            throw new Error(err);
          },
        };
        const currUrl = window.location.href;
        this.getAuth.parseCognitoWebResponse(currUrl);
      }
      this.form.email = Storage.get(this.storageEmailKey) || this.form.email;
      this.form.saveEmail = !!this.form.email;
      this.$emit('update:email', this.form.email);
      this.$emit('update:saveEmail', this.form.saveEmail);
    },
    components: {
      ScField,
      ScSwitch,
      ScInput,
      ScButton,
    },
  };
</script>

<style lang="scss" scoped>
  .login__switchbox {
    display: flex;
    flex-direction: column;
    margin-bottom: 1.5rem;
    &-switch {
      margin: 0 0 .5rem 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/features/public/login/default/forms/FormEmail.vue?210bf3e6